import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import DivBottom from '../userNotAuth/components/divBottom'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import { useDispatch, useSelector } from 'react-redux'
import { aggiorna } from '../../redux/creaEvento'

function CreaEvento() {
    window.scrollTo(0, 0)
    const dispatch = useDispatch()
    let redux = useSelector((state) => state.creaEvento.value)
    redux = { ...redux, newVideo: null, video: null }
    dispatch(aggiorna(redux))
    const logged = localStorage.getItem('logged')
    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <div className='bodyPadding'>
            <h2 style={{ marginTop: '7rem' }}>Evento creato</h2><hr />
            <h5 style={{ margin: '3rem 0 14rem 0' }}>
                L'evento è stato creato ma prima di essere pubblicato dovrà essere approvato dal nostro staff.
                {logged &&
                    <p>Potrai modificare o annullare l'evento in qualunque momento dal menù <i>My eventi</i>.</p>
                }
                <div className='mt-5'>
                    <a href="/" className='btn btn-secondary'>👉 Torna alla home</a>
                </div>
            </h5>
        </div>
        <DivBottom />
    </>)
}
export default CreaEvento
